export enum DateEnum {
  dateInputWithFullYear = 'MM/DD/YYYY',
  dateInputWithTwoYearDigits = 'MM/DD/YY',

}
